import { Card } from 'components/Card';
import { CardGeneric } from 'components/CardGeneric';
import { CardRow } from 'components/CardRow';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { Txt } from 'components/Txt';
import { useEsc } from 'hooks/useEsc';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';

export const ListDisplayModal: React.FC<
  ModalScreenProps<ModalScreens.ListDisplay>
> = ({ route }) => {
  const dispatch = useDispatch();
  const { cardLabel, emptyText, rows = [], text, title } = route.params;

  const handleClose = React.useCallback(
    () => dispatch(NAVIGATE_MODAL_BACK([ModalScreens.ListDisplay])),
    [dispatch],
  );

  useEsc(handleClose);

  return (
    <Page
      scrollView
      header={<PageHeader title={title} onPressCloseButton={handleClose} />}
    >
      {!!text && (
        <CardGeneric style={styles.infoCard}>
          <Txt>{text}</Txt>
        </CardGeneric>
      )}
      <Card label={cardLabel}>
        {rows.length ? (
          rows.map((row, index) => (
            <CardRow
              key={`${row.label || row.value || index}-${index}`}
              label={row.label}
              label2={row.label2}
              label2NumberOfLines={2}
              labelAlignTop={!!row.label2 || !!row.value}
              value={row.value}
              placeholder={row.placeholder}
              icon={row.icon}
              iconColor={row.iconColor}
            />
          ))
        ) : (
          <CardRow placeholder={emptyText || 'No Items'} />
        )}
      </Card>
    </Page>
  );
};

type ListDisplayModalStyles = {
  infoCard: React.ComponentProps<typeof CardGeneric>['style'];
};

const styles: ListDisplayModalStyles = {
  infoCard: {
    marginBottom: theme.padding,
  },
};
